export default __webpack_public_path__ + "static/media/mp.ae757cbe.jpg";